module.exports = __webpack_public_path__ + "static/media/waveBottom.b45f5449.svg";